import React, { useContext } from "react";
import useStyles from "./styles";
import { WalletItems } from "../../App";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import cardImageDefault from '../../assets/images/card-default.png';
import cardImageW from '../../assets/images/mc-w-card.png';
import cardImageWE from '../../assets/images/mc-we-card.png';
import cardImageP from '../../assets/images/mc-p-card.png';
import cardImageT from '../../assets/images/mc-t-card.png';
import noCardImage from '../../assets/images/nocard.svg';

const WalletItemsCard = ({ walletItem, setWalletItem }) => {
    const walletItems = useContext(WalletItems);
    const classes = useStyles();

    if (!walletItems || !walletItems.length) {
        return <></>
    }

    const handleChange = (e, value) => {
        if (!value) return;
        setWalletItem(value.id ? value : undefined);
    };

    const getImage = (item) => {
        if (!item?.paymentMethod?.card?.description) return cardImageDefault;
        const desc = item.paymentMethod.card.description.toUpperCase();
        if (desc.includes('WORLD ELITE')) return cardImageWE;
        else if (desc.includes('WORLD')) return cardImageW;
        else if (desc.includes('TITANIUM')) return cardImageT;
        else if (desc.includes('PLATINUM')) return cardImageP;
        return cardImageDefault;
    }

    return (
        <div className={classes.walletItemsContainer}>
            <ToggleButtonGroup
                size="large"
                exclusive
                value={walletItem}
                onChange={handleChange}
                name="wallet-items"
                className={`${classes.buttonGroup} input_label_text`}
            >
                {
                    walletItems.slice(0, 2).map((item, index) => (
                        <ToggleButton key={index} value={item} aria-label={item.id} className={`${classes.button} pay_method_text`}>
                            <div className={`${classes.buttonWrap}`}>
                                <span>
                                <img className={`${classes.cardImage}`} src={getImage(item)} alt={item?.paymentMethod?.card?.description ?? ''}/>
                                </span>
                                <span className={`${classes.cardName} pay_method_text`}>{item?.paymentMethod?.card?.description ?? ''}</span>
                                <i className={`${classes.cardNumb}`}>**** {item?.paymentMethod?.card?.last4 ?? ''}</i>
                            </div>
                        </ToggleButton>
                    ))
                }
                <ToggleButton selected={!walletItem} value={{}} className={`${classes.button} pay_method_text`}>
                    <div className={`${classes.buttonWrap}`}>
                        <span>
                            <img className={`${classes.cardImage} ${classes.noCardImage}`} src={noCardImage} alt="Add Card" />
                        </span>
                        <span className={`${classes.cardName} pay_method_text`}>Add Card</span>
                        <i className={`${classes.cardNumb}`}>Details</i>
                    </div>
                </ToggleButton>
            </ToggleButtonGroup>
        </div>
    );
}

export default WalletItemsCard;